import { action, select } from 'satcheljs/lib/legacy';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { getNow } from '../utils/getNow';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import {
    lazyUserInitiatedWebPushDisableWorkflow,
    lazyLoadWebPushOptions,
    getLocalWebPushUserSettingStore,
    LocalWebPushUserSetting,
    logDisableStart,
    logWorkFlowEnd,
} from 'owa-webpush-notifications';
import {
    getOptionsForFeature,
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
    WebPushNotificationsOptions,
} from 'owa-outlook-service-options';
import strings from 'owa-strings/owa-options-strings';

export const tryDisableAllWebPushNotifications = () =>
    confirm(
        strings.webpushDisableAllConfirmDialogHeader,
        strings.webpushDisableAllConfirmDialogBody,
        false,
        {}
    ).then(response => {
        if (response === DialogResponse.ok) {
            disableAllWebPushNotifications();
        }
    });

export interface DisableWebPushNotificationsOptionState {
    userOptions?: WebPushNotificationsOptions;
    localWebPushUserSetting: LocalWebPushUserSetting;
    windowObj: Window;
}

let disableAllWebPushNotifications = select<DisableWebPushNotificationsOptionState>({
    userOptions: () =>
        getOptionsForFeature<WebPushNotificationsOptions>(
            OwsOptionsFeatureType.WebPushNotifications
        ),
    localWebPushUserSetting: () => getLocalWebPushUserSettingStore(),
    windowObj: () => window,
})(
    action('disableAllWebPushNotifications')(async function disableAllWebPushNotifications(
        state?: DisableWebPushNotificationsOptionState
    ) {
        let { userOptions, localWebPushUserSetting, windowObj } = state;
        userOptions.enabled = false;
        localWebPushUserSetting.enabled = false;
        userOptions.enabledTimeInUTCMs = getNow().toString();
        const userInitiatedWebPushDisableWorkflow = await lazyUserInitiatedWebPushDisableWorkflow.import();
        const loadWebPushOptions = await lazyLoadWebPushOptions.import();
        logDisableStart('settings', true);

        // Disable local subscription
        let disabled = await userInitiatedWebPushDisableWorkflow(
            windowObj,
            await loadWebPushOptions(),
            getUserConfiguration().SessionSettings.MailboxGuid,
            true
        );

        // Update Server to disable from other clients
        await lazyCreateOrUpdateOptionsForFeature.importAndExecute(
            OwsOptionsFeatureType.WebPushNotifications,
            userOptions
        );

        logWorkFlowEnd(disabled);
    })
);
